// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  margin: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: Calibri, sans-serif !important;
}

html {
  white-space: nowrap;
}

body {
  overflow-x: hidden;
  display: inline-block;
}

tr,
td {
  height: 10px !important;
}

body::-webkit-scrollbar {
  width: 0.4em !important;
}

body::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(250, 244, 244, 0.3) !important;
}

body::-webkit-scrollbar-thumb {
  background-color: darkgrey !important;
}`, "",{"version":3,"sources":["webpack://./src/app/App.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":["body,\nhtml {\n  margin: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  font-family: Calibri, sans-serif !important;\n}\n\nhtml {\n  white-space: nowrap;\n}\n\nbody {\n  overflow-x: hidden;\n  display: inline-block;\n}\n\ntr,\ntd {\n  height: 10px !important;\n}\n\nbody::-webkit-scrollbar {\n  width: 0.4em !important;\n}\n\nbody::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(250, 244, 244, 0.3) !important;\n}\n\nbody::-webkit-scrollbar-thumb {\n  background-color: darkgrey !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
